<div class="component-modal-header">
  <span class="modal-title">{{worker.workerUser.firstName}} {{worker.workerUser.lastName}} - Training Courses</span>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span class="pi pi-times"></span></button>
</div>

<div class="modal-body">
  <h6 class="card-title"></h6>

  <div class="form-row">
    <div class="col-md-12">

      <h6 class="card-title">Training Courses</h6>

      <auto-table
        [emptyMessage]="'No existing training courses'"
        [rows]="existingCourses"
        [cols]="[
          { field: 'trainingName', header: 'Name' },
          { field: 'courseProgress', header: 'Status', type: 'training_course_status' },
          { field: 'expiryDate', header: 'Expiry Date', type: 'date', dateFormat: 'yyyy-MM-dd' }
        ]"
      ></auto-table>

    </div>
  </div>

  <br>
  <br>
  <br>

  <h6 class="card-title">Assign a new Course to this worker</h6>
  <div class="form-row">
    <div class="col-md-12" *ngIf="!availableTrainingCourses.length">
      <div>No courses with type 'Training' have been created</div>
    </div>
    <div class="col-md-12" *ngIf="availableTrainingCourses.length">

      <div class="form-group">
        <label>Training Course </label>
        <p-dropdown
            class="pDropdownCustom"
            [(ngModel)]="selectedTraining"
            [ngModelOptions]="{standalone: true}"
            [options]="availableTrainingCourses"
            optionLabel="label"
            placeholder="Choose A Training Course"
            filter="true">
        </p-dropdown>
      </div>
    </div>
  </div>

  <br>
  <div class="form-row">
    <div class="col-md-12 mt-4 mb-4">
      <button [disabled]="!this.selectedTraining" type="submit" class="btn btn-success btn-round float-right" (click)="onSubmit()">Add</button>
    </div>
  </div>

</div>
